import {routes} from '../router/routes';
import {routes as routesAdmin} from './admin/AppAdmin/routes/routes';
import {routes as routesAdminLogin} from './admin/Auth/routes/routes';
import {routes as routesProgramme} from './admin/Programme/routes/routes';

export const allRoutes = routes.concat(routesAdmin)
                        .concat(routesAdminLogin)
                        .concat(routesProgramme);
